<template>
  <div class="logistics-details__status">
    <div class="logistics-infomation  pad-mar__title" v-min-height>
      <h3 class="title">
        物流信息
        <el-form label-width="auto" :inline="true">
          <el-form-item label="订单号：">
            {{ form.paySn }}
          </el-form-item>
          <el-form-item label="快递公司：">
            {{ form.expressName }}
          </el-form-item>
          <el-form-item label="快递单号：">
            {{ form.shippingCode }}
          </el-form-item>
        </el-form>
      </h3>
      <div class="time-line">
        <el-timeline :reverse="false">
          <el-timeline-item v-for="(item, index) in form.info" :key="index" :timestamp="item.dateTime" placement="top"
            :icon="index === 0 ? 'iconfont icon-yuandian' : ''">
            <!--            <div class="coordinate">-->
            <!--              <i class="iconfont icon-weizhi"></i>-->
            <!--              <span class="city">上海市</span>-->
            <!--            </div>-->
            <span class="info-status">{{ item.flag }} </span>
            <p class="tips">{{ item.des }}</p>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogisticsDetails',
  data() {
    this.keyMap = {
      order_info: {
        name: 'logisticsInfo',
        express_message: 'info',
        sign: 'flag',
        date_time: 'dateTime',
        describe: 'des',
        pay_sn: 'paySn',
        shipping_code: 'shippingCode',
        express_name: 'expressName'
      }
    }
    return {
      form: {}
    }
  },
  watch: {
    $route: {
      handler: function (to) {
        const id = to.query.id
        const data = to.meta.title.includes('换货')
          ? { refund_id: id }
          : { order_id: id }
        this._getLogisticsInfo(data)
      },
      immediate: true
    }
  },
  methods: {
    _getLogisticsInfo(params) {
      this.api.getLogisticsInfo(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.form = res.logisticsInfo
      })
    }
  }
}
</script>

<style lang="scss">
.logistics-details__status {
  .logistics-infomation {
    .icon-yuandian {
      font-size: 1.5rem;
      color: colors('bg-sub');
    }

    .el-form {
      float: right;
      margin-top: -8px;

      .el-form-item {
        position: relative;

        &:nth-child(2) {
          margin: 0 4.4rem;
        }

        &:before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          width: 6px;
          height: 6px;
          margin: auto;
          border-radius: 50%;
          display: initial;
        }

        &:nth-child(1) {
          &:before {
            background-color: colors('bg-sub');
          }
        }

        &:nth-child(2) {
          &:before {
            background-color: colors('d5');
            left: -1rem;
          }
        }

        &:nth-child(3) {
          &:before {
            background-color: colors('2d');
            left: -1rem;
          }
        }
      }

      .el-form-item__label {
        font-weight: bold;
        font-size: 0.9rem;
        padding: 0;
      }

      .el-form-item__content {
        font-weight: normal;
      }
    }

    .title {
      margin-right: 3.2rem;
      padding-bottom: 1.8rem;
      border-bottom: 1px solid colors('bor-main');
    }

    .time-line {
      padding-left: 100px;
    }

    .el-timeline-item__tail {
      border-color: #f3f3f3;
    }

    .el-timeline-item__node {
      background-color: #f3f3f3;
    }

    .el-timeline-item__wrapper {
      padding-left: 80px;
    }

    .info-status {
      position: absolute;
      top: 0;
      left: 20px;
    }

    .icon-weizhi {
      font-size: 1.5rem;
      vertical-align: sub;
    }

    .city {
      padding-left: 1rem;
      font-size: 0.9rem;
    }

    .coordinate {
      position: absolute;
      top: -5px;
      left: -100px;
    }

    .invoice-information {
      min-height: 26.3rem;
    }
  }
}
</style>
